import { Component } from '@angular/core';
import { SummarizeService } from '../summarize.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-summarize',
  templateUrl: './summarize.component.html',
  styleUrls: ['./summarize.component.scss']
})
export class SummarizeComponent {

  hideLeftContent:boolean=true;
  summarizationDataList:any=[];
  showPaginateSpinner:boolean=false;
  constructor(private summarizeService:SummarizeService){
    
  }

  ngOnInit(){
    this.getBotHistory();
  }


  summaryResponse(event:any){
    let user_id = window.localStorage.getItem('user_id');
                let botPayload ={
                "user_id":user_id,
                "question":"summarization",
                "answer":event,
                "question_type":"summary",
                "bot_type":"bot",
                "sequence_id":new Date().valueOf()
                };
                this.summarizeService.createHistory(botPayload).subscribe((result:any)=>{
                  if(result['success']){
                    let data={};
                    data["question_type"]="history";
                    data["bot_answer"]=botPayload['answer'];
                    data["sequence_id"]=result['createdMessage']["sequence_id"];
                    data["history_id"] = result['createdMessage']["history_id"];
                    data["created_at"] = new Date();
                 
                    this.summarizationDataList.unshift(data);
                  }
                });   
   
  }


  getBotHistory(){
    this.showPaginateSpinner=true;
    this.summarizeService.getChatBotHistory().subscribe((result:any)=>{
        if(result['success']){
          this.showPaginateSpinner = false;
            let data = result['result'];
            if(data.length > 0){
              this.summarizationDataList=[];
          let summaryData =    result['result'].filter((item:any)=>item['question_type']=="summary");
          this.summarizationDataList=summaryData;
           }
          
        }else{
          this.showPaginateSpinner = false;
        }
    },(error:HttpErrorResponse)=>{
      this.showPaginateSpinner = false;
    });
  }

}
